import React from "react";
import { useEffect, useState } from "react";
import { GraphDropDown } from "../../components/Graphs/GraphDropDown";
import "../../components/Graphs/graphStyles.scss";
import { FirebaseDataService } from "../../services/firebase-data.service.jsx";
import {
  setFirstSources,
  setLastSources,
  setUniqueSales,
  setWeeklyData,
  setBiWeeklyData,
  setMonthlyData,
  setQuarterlyData,
  setHalfYearlyData,
  setOriginalFirstSources,
  setOriginalLastSources,
  setOriginalUniqueSales,
  setDates,
  setAllDates,
  setDateType,
  setCurrentDate,
} from "./firstlastSlice";
import { useDispatch, useSelector } from "react-redux";
import { LoadingAnimation } from "../../components/Loading/LoadingAnimation";
import { DateTypeDropdown } from "./DateTypeDropdown";
import { arrows } from "../../assets/index";
import {
  calcBiWeeklyData,
  calcMonthlyData,
  calcQuarterlyData,
  calcHalfYearlyData,
} from "./calcDateData";
import { ExportCSVButton } from "../../components/ExportCSVButton";
import { TouchGraph2 } from "./TouchGraph2";
import { selectLogInUsername, selectUserStatus } from "../../common/authenticateDashboard/authSlice.js";
import FirstLastTouchLoading from "../../components/Skeletons/FirstLastTouchLoading.jsx";

const DATEOPTIONS = [
  "Weekly",
  "Bi-Weekly",
  "Monthly",
  "Quarterly",
  "Half-Yearly",
  "Yearly",
];

const MONTHS = {
  "01": "January",
  "02": "Feburary",
  "03": "March",
  "04": "April",
  "05": "May",
  "06": "June",
  "07": "July",
  "08": "August",
  "09": "September",
  "10": "October",
  "11": "November",
  "12": "December",
};

const QUARTERS = {
  "01": "Jan-Mar",
  "02": "Jan-Mar",
  "03": "Jan-Mar",
  "04": "Apr-Jun",
  "05": "Apr-Jun",
  "06": "Apr-Jun",
  "07": "Jul-Sep",
  "08": "Jul-Sep",
  "09": "Jul-Sep",
  "10": "Oct-Dec",
  "11": "Oct-Dec",
  "12": "Oct-Dec",
};

const HALFYEARS = {
  "01": "Jan-Jun",
  "02": "Jan-Jun",
  "03": "Jan-Jun",
  "04": "Jan-Jun",
  "05": "Jan-Jun",
  "06": "Jan-Jun",
  "07": "Jul-Dec",
  "08": "Jul-Dec",
  "09": "Jul-Dec",
  "10": "Jul-Dec",
  "11": "Jul-Dec",
  "12": "Jul-Dec",
};

const FirstLastTouch = () => {
  const [funnelOptimizerFetchLoading, setFunnelOptimizerFetchLoading] =
    useState(true);
  const [optimizerStatus, setOptimizerStatus] = useState(false);
  const userStatus = useSelector(selectUserStatus)
  const dispatch = useDispatch();
  const sessionUser = useSelector(selectLogInUsername)
  const user = sessionUser?.split('@')[0];
  const firebaseDataService = new FirebaseDataService();
  const [loading, setLoading] = React.useState(true);


  useEffect(() => {
    if (userStatus?.funnel_optimizer) setOptimizerStatus(true);
    setFunnelOptimizerFetchLoading(false);
  }, [userStatus])


  // Dates for dropdown
  const weekly = useSelector((state) => state.firstLast.allDates.weekly);
  const biWeekly = useSelector((state) => state.firstLast.allDates.biWeekly);
  const monthly = useSelector((state) => state.firstLast.allDates.monthly);
  const quarterly = useSelector((state) => state.firstLast.allDates.quarterly);
  const halfYearly = useSelector(
    (state) => state.firstLast.allDates.halfYearly
  );

  // Data for the different date types, combined and without duplicated
  const weeklyData = useSelector((state) => state.firstLast.weeklyData);
  const biWeeklyData = useSelector((state) => state.firstLast.biWeeklyData);
  const monthlyData = useSelector((state) => state.firstLast.monthlyData);
  const quarterlyData = useSelector((state) => state.firstLast.quarterlyData);
  const halfYearlyData = useSelector((state) => state.firstLast.halfYearlyData);

  // Current array of dates to be displayed and current date and date type
  const currentDate = useSelector((state) => state.firstLast.currentDate);
  const dates = useSelector((state) => state.firstLast.dates);
  const dateType = useSelector((state) => state.firstLast.dateType);

  // Main data that is displayed
  const firstSources = useSelector((state) => state.firstLast.firstSources);
  const lastSources = useSelector((state) => state.firstLast.lastSources);
  const uniqueSales = useSelector((state) => state.firstLast.uniqueSales);

  // Just for search bar use
  const originalFirstSources = useSelector(
    (state) => state.firstLast.originalFirstSources
  );
  const originalLastSources = useSelector(
    (state) => state.firstLast.originalLastSources
  );
  const originalUniqueSales = useSelector(
    (state) => state.firstLast.originalUniqueSales
  );

  // Searchable items
  const [query1, setQuery1] = useState("");
  const [query2, setQuery2] = useState("");



  // Handles the search bars
  useEffect(() => {
    /*  <-- First Search bar --> */
    let newFirstFiltered = [],
      newLastFiltered = [],
      newSalesFiltered = [];
    let newFirst = [],
      newLast = [],
      newSales = [];

    if (originalFirstSources[currentDate] !== undefined) {
      for (let i = 0; i < originalFirstSources[currentDate].length; i++) {
        if (
          originalFirstSources[currentDate][i]
            .toLowerCase()
            .includes(query1.toLowerCase())
        ) {
          newFirstFiltered.push(originalFirstSources[currentDate][i]);
          newLastFiltered.push(originalLastSources[currentDate][i]);
          newSalesFiltered.push(originalUniqueSales[currentDate][i]);
        }
      }
      // Retrieve original data from before search
      newFirst = [...originalFirstSources];
      newLast = [...originalLastSources];
      newSales = [...originalUniqueSales];
      // Update copies of original data to change current week data
      newFirst[currentDate] = newFirstFiltered;
      newLast[currentDate] = newLastFiltered;
      newSales[currentDate] = newSalesFiltered;
    }

    /*  <--  Second Search bar  -->  */

    // Reset temporary data
    newFirstFiltered = [];
    newLastFiltered = [];
    newSalesFiltered = [];

    if (newLast[currentDate] !== undefined) {
      for (let i = 0; i < newLast[currentDate].length; i++) {
        if (
          newLast[currentDate][i].toLowerCase().includes(query2.toLowerCase())
        ) {
          newFirstFiltered.push(newFirst[currentDate][i]);
          newLastFiltered.push(newLast[currentDate][i]);
          newSalesFiltered.push(newSales[currentDate][i]);
        }
      }
      // Update copies of original data to change current week data
      newFirst[currentDate] = newFirstFiltered;
      newLast[currentDate] = newLastFiltered;
      newSales[currentDate] = newSalesFiltered;
    }
    // update searchable versions of the data
    dispatch(setFirstSources(newFirst));
    dispatch(setLastSources(newLast));
    dispatch(setUniqueSales(newSales));
  }, [query2, query1]);

  /**
   * Retrieves all data, sets allData, weeks, and currentWeek states,
   * and formats the string representations of weeks.
   */
  useEffect(() => {
    if (!user) return null;
    const fetchData = async () => {
      try {
        const statsObj = user + "/graph-first_last_touch";
        if (weekly.length === 0) {
          firebaseDataService
            .graphInfiniteStat(statsObj,user, "graph-first_last_touch", "firstLastTouch")
            .subscribe((data) => {
              let week_list = [].concat(data[0]);
              let week_list_dashed = week_list?.map((week_label) => {
                week_label = String(week_label);
                let year = week_label.substring(0, 4);
                let month = week_label.substring(4, 6);
                let week = week_label.substring(6, 8);
                return year + "-" + month + "-" + week;
              });

              // Get only unique data points in array -> unique monthly dates
              function onlyUnique(value, index, array) {
                return array.indexOf(value) === index;
              }

              // Monthly dates
              const monthArr = week_list_dashed
                ?.map((value) => {
                  return (
                    MONTHS[`${value.substring(5, 7)}`] +
                    " " +
                    value.substring(0, 4)
                  );
                })
                .filter(onlyUnique);
              // Quarterly dates
              const quarterArr = week_list_dashed
                ?.map((value) => {
                  return (
                    QUARTERS[`${value.substring(5, 7)}`] +
                    " " +
                    value.substring(0, 4)
                  );
                })
                .filter(onlyUnique);
              // HalfYearly dates
              const halfYearlyArr = week_list_dashed
                ?.map((value) => {
                  return (
                    HALFYEARS[`${value.substring(5, 7)}`] +
                    " " +
                    value.substring(0, 4)
                  );
                })
                .filter(onlyUnique);

              // Set bi-weekly, monthly, bi-monthly, yearly dates
              dispatch(
                setAllDates({
                  weekly: week_list_dashed?.slice().reverse(),
                  biWeekly: week_list_dashed
                    .filter((value, index) => index % 2 === 0)
                    .slice()
                    .reverse(),
                  monthly: monthArr.slice().reverse(),
                  quarterly: quarterArr.slice().reverse(),
                  halfYearly: halfYearlyArr.slice().reverse(),
                })
              );

              // Set dates default starting value to weekly data
              dispatch(setDates(week_list_dashed.slice().reverse()));

              // Set all data
              let allData = Object.values(data[1]);
              let firstDataArr = [];
              let lastDataArr = [];
              let uniqueSalesArr = [];

              for (let i = 0; i < allData.length; i++) {
                // Set total data for each column through all weeks in 2d array
                let tempFirstData = [];
                let tempLastData = [];
                let tempUniqueSalesData = [];
                for (let k = 0; k < allData[i].length; k++) {
                  // Set each week's data
                  tempFirstData[k] = allData[i][k].first_source;
                  tempLastData[k] = allData[i][k].last_source;
                  tempUniqueSalesData[k] = allData[i][k].no_of_unique_sales;
                }
                firstDataArr[i] = tempFirstData;
                lastDataArr[i] = tempLastData;
                uniqueSalesArr[i] = tempUniqueSalesData;
              }
              // Reverse all data to match reversing of week dates
              firstDataArr = firstDataArr.reverse();
              lastDataArr = lastDataArr.reverse();
              uniqueSalesArr = uniqueSalesArr.reverse();
              // Set all date data for dropdown menus
              dispatch(
                setWeeklyData({
                  firstSources: firstDataArr,
                  lastSources: lastDataArr,
                  uniqueSales: uniqueSalesArr,
                })
              );
              // Initialize data values to the weekly data arrays
              dispatch(setFirstSources(firstDataArr));
              dispatch(setLastSources(lastDataArr));
              dispatch(setUniqueSales(uniqueSalesArr));
              // Data for search bar
              dispatch(setOriginalFirstSources(firstDataArr));
              dispatch(setOriginalLastSources(lastDataArr));
              dispatch(setOriginalUniqueSales(uniqueSalesArr));
              // Calculate all new arrays of data based on date option selected
              // And combines likes rows and their number of unique sales
              dispatch(
                setBiWeeklyData(
                  calcBiWeeklyData(firstDataArr, lastDataArr, uniqueSalesArr)
                )
              );
              dispatch(
                setMonthlyData(
                  calcMonthlyData(
                    firstDataArr,
                    lastDataArr,
                    uniqueSalesArr,
                    week_list_dashed
                  )
                )
              );
              dispatch(
                setQuarterlyData(
                  calcQuarterlyData(
                    firstDataArr,
                    lastDataArr,
                    uniqueSalesArr,
                    week_list_dashed
                  )
                )
              );
              dispatch(
                setHalfYearlyData(
                  calcHalfYearlyData(
                    firstDataArr,
                    lastDataArr,
                    uniqueSalesArr,
                    week_list_dashed
                  )
                )
              );
            });
        }
        setDates(weekly);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [user]);

  /**
   * When dateType is change by clicking button from middle dropdown,
   * changes firstSources, lastSources, uniqueSales states to match the
   * data from that particular date type selected
   */
  useEffect(() => {
    const changeData = () => {
      if (firstSources.length !== 0) {
        switch (dateType) {
          case 0:
            if (dates !== weekly) {
              dispatch(setDates(weekly));
              dispatch(setFirstSources(weeklyData.firstSources));
              dispatch(setLastSources(weeklyData.lastSources));
              dispatch(setUniqueSales(weeklyData.uniqueSales));
              dispatch(setOriginalFirstSources(weeklyData.firstSources));
              dispatch(setOriginalLastSources(weeklyData.lastSources));
              dispatch(setOriginalUniqueSales(weeklyData.uniqueSales));
              dispatch(dispatch(setCurrentDate(0)));
              setQuery1("");
              setQuery2("");
            }
            break;
          case 1:
            if (dates !== biWeekly) {
              dispatch(setDates(biWeekly));
              dispatch(setFirstSources(biWeeklyData.firstSources));
              dispatch(setLastSources(biWeeklyData.lastSources));
              dispatch(setUniqueSales(biWeeklyData.uniqueSales));
              dispatch(setOriginalFirstSources(biWeeklyData.firstSources));
              dispatch(setOriginalLastSources(biWeeklyData.lastSources));
              dispatch(setOriginalUniqueSales(biWeeklyData.uniqueSales));
              dispatch(setCurrentDate(0));
              setQuery1("");
              setQuery2("");
            }
            break;
          case 2:
            if (dates !== monthly) {
              dispatch(setDates(monthly));
              dispatch(setFirstSources(monthlyData.firstSources));
              dispatch(setLastSources(monthlyData.lastSources));
              dispatch(setUniqueSales(monthlyData.uniqueSales));
              dispatch(setOriginalFirstSources(monthlyData.firstSources));
              dispatch(setOriginalLastSources(monthlyData.lastSources));
              dispatch(setOriginalUniqueSales(monthlyData.uniqueSales));
              dispatch(setCurrentDate(0));
              setQuery1("");
              setQuery2("");
            }
            break;
          case 3:
            if (dates !== quarterly) {
              dispatch(setDates(quarterly));
              dispatch(setFirstSources(quarterlyData.firstSources));
              dispatch(setLastSources(quarterlyData.lastSources));
              dispatch(setUniqueSales(quarterlyData.uniqueSales));
              dispatch(setOriginalFirstSources(quarterlyData.firstSources));
              dispatch(setOriginalLastSources(quarterlyData.lastSources));
              dispatch(setOriginalUniqueSales(quarterlyData.uniqueSales));
              dispatch(setCurrentDate(0));
              setQuery1("");
              setQuery2("");
            }
            break;
          default:
            if (dates !== halfYearly) {
              dispatch(setDates(halfYearly));
              dispatch(setFirstSources(halfYearlyData.firstSources));
              dispatch(setLastSources(halfYearlyData.lastSources));
              dispatch(setUniqueSales(halfYearlyData.uniqueSales));
              dispatch(setOriginalFirstSources(halfYearlyData.firstSources));
              dispatch(setOriginalLastSources(halfYearlyData.lastSources));
              dispatch(setOriginalUniqueSales(halfYearlyData.uniqueSales));
              dispatch(setCurrentDate(0));
              setQuery1("");
              setQuery2("");
            }
            break;
        }
      }
    };
    changeData();
  }, [dateType, currentDate]);

  /**
   * Takes in a column index to sort alphabetically,
   * Creates a 2D array of rows to sort every row according to the one
   * values on the specified column, sorts, and updates main 3 states
   *
   * @param {*} currIndex current column index to sort
   */
  function sortColumn(currIndex) {
    let rows = [];
    firstSources[currentDate].forEach((value, index) => {
      rows[index] = [
        value,
        lastSources[currentDate][index],
        uniqueSales[currentDate][index],
      ];
    });

    // If sorted array equals current array, reverse sort
    if (rows[0] === rows.sort(sortFunction)[0]) {
      let sortedFirst = [...firstSources];
      sortedFirst[currentDate] = getColumn(
        [...rows].sort(reverseSortFunction),
        0
      );
      let sortedLast = [...lastSources];
      sortedLast[currentDate] = getColumn(
        [...rows].sort(reverseSortFunction),
        1
      );
      let sortedSales = [...uniqueSales];
      sortedSales[currentDate] = getColumn(
        [...rows].sort(reverseSortFunction),
        2
      );
      dispatch(setFirstSources(sortedFirst));
      dispatch(setLastSources(sortedLast));
      dispatch(setUniqueSales(sortedSales));
    } else {
      let sortedFirst = [...firstSources];
      sortedFirst[currentDate] = getColumn([...rows].sort(sortFunction), 0);
      let sortedLast = [...lastSources];
      sortedLast[currentDate] = getColumn([...rows].sort(sortFunction), 1);
      let sortedSales = [...uniqueSales];
      sortedSales[currentDate] = getColumn([...rows].sort(sortFunction), 2);
      dispatch(setFirstSources(sortedFirst));
      dispatch(setLastSources(sortedLast));
      dispatch(setUniqueSales(sortedSales));
    }

    function sortFunction(a, b) {
      if (currIndex === 2) {
        return a[currIndex] - b[currIndex];
      } else {
        return a[currIndex].toLowerCase() < b[currIndex].toLowerCase() ? -1 : 1;
      }
    }
    function reverseSortFunction(a, b) {
      if (currIndex === 2) {
        return b[currIndex] - a[currIndex];
      } else {
        return b[currIndex].toLowerCase() < a[currIndex].toLowerCase() ? -1 : 1;
      }
    }
    // Helper function to retrieve column of array
    // and return it as an array
    function getColumn(arr, ind) {
      let newArr = [];
      arr.forEach((value, index) => {
        newArr[index] = value[ind];
      });
      return newArr;
    }
  }

  // State flag that control layout styling at different widths
  const [layoutWidthFlag, setLayoutWidthFlag] = React.useState(
    window.innerWidth >= 640 ? false : true
  );
  const [isMobile, setIsMobile] = React.useState(
    window.innerWidth >= 768 ? false : true
  );
  const [titleFlag, setTitleFlag] = React.useState(
    window.innerWidth >= 830 ? false : true
  );
  // check if the screen is mobile for header layout
  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 768) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
      if (window.innerWidth < 640) {
        setLayoutWidthFlag(true);
      } else {
        setLayoutWidthFlag(false);
      }
      if (window.innerWidth < 830) {
        setTitleFlag(true);
      } else {
        setTitleFlag(false);
      }
    }
    window.addEventListener("resize", handleResize);
    handleResize(); // initial check
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // State changing functions to be passed into components
  function changeDateType(num) {
    dispatch(setDateType(num));
  }

  // State changing functions to be passed into components
  function changeCurrentDate(num) {
    dispatch(setCurrentDate(num));
  }

  if (funnelOptimizerFetchLoading === true) {
    return <FirstLastTouchLoading />;
  }

  return (
    <>
      {optimizerStatus ? (
        <div className="flex-grow p-3.5">
          <div className="graph rounded-2 mb-5">
            {/* Graph header */}
            <div className="flex justify-center sm:justify-between align-items-center p-2.5 px-2.5 bg-[rgba(0,0,0,0.05)] flex-wrap gap-2">
              {/* Title */}
              <div className="text-sm sm:text-base">
                First and last touch insights
              </div>
              {/* Drop down buttons and CVS Button */}
              <div className="flex sm:w-2/3 sm:justify-between">
                <div className="flex">
                  <DateTypeDropdown
                    dateType={DATEOPTIONS[dateType]}
                    setDateType={changeDateType}
                  />
                  <GraphDropDown
                    display={"firstlasttouch"}
                    currentWeek={currentDate}
                    setCurrentWeek={changeCurrentDate}
                    weeks={dates}
                  />
                </div>
                <div>
                  <ExportCSVButton
                    allData={
                      firstSources[currentDate] === undefined
                        ? []
                        : [
                            ["First Source", ...firstSources[currentDate]],
                            ["Last Source", ...lastSources[currentDate]],
                            [
                              "Number of Unique Sales",
                              ...uniqueSales[currentDate],
                            ],
                          ]
                    }
                    name={"First_Last_Touch_Insight"}
                    style={{
                      fontSize: "13px",
                      height: "37.5px",
                      marginTop: "4px",
                      maxWidth: "105px",
                      marginRight: "0px",
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="p-3">
              {/* Search bar row */}
              <div className="h-10 flex justify-content-between mb-3">
                {/* Search bar */}
                <input
                  type="search"
                  className="touch__search touch__search1"
                  value={query1}
                  onChange={(e) => {
                    setQuery1(e.target.value);
                  }}
                  placeholder="Search First Sources"
                />
                {/* Search bar 2 */}
                <input
                  type="search"
                  className="touch__search touch__search2"
                  value={query2}
                  onChange={(e) => {
                    setQuery2(e.target.value);
                  }}
                  placeholder="Search Last Sources"
                />
              </div>

              <div
                className="flex flex-col"
                style={{ border: "1px solid rgba(0,0,0,0.1)" }}
              >
                {/* Header row with labels */}
                <div
                  className="fw-bold flex text-xs sm:text-sm"
                  style={{ border: "1px solid rgba(0,0,0,0.1)" }}
                >
                  {/* First Source Label */}
                  <div
                    className="flex mr-0 pl-2"
                    style={{ width: "45%", maxWidth: "22vw" }}
                  >
                    {/* Reversing data button */}
                    <button
                      className="mt-2.5 mb-2.5 text-nowrap flex gap-0.5"
                      onClick={() => sortColumn(0)}
                    >
                      <div>First Source</div>
                      <img
                        src={arrows}
                        style={{ width: "17px", marginTop: "1px" }}
                        alt="arrows-svg"
                      />
                    </button>
                  </div>
                  {/* Last Source Label */}
                  <div className="flex mx-0 pl-2 w-[55%] max-w-[35vw] sm:max-w-[37vw]">
                    {/* Reversing data button */}
                    <button
                      className="mt-2.5 text-nowrap flex gap-0.5"
                      onClick={() => sortColumn(1)}
                    >
                      <div>Last Source</div>
                      <img
                        src={arrows}
                        style={{ width: "17px", marginTop: "1px" }}
                        alt="arrows-svg"
                      />
                    </button>
                  </div>
                  {/* Unique Sales Label */}
                  <div className="flex relative" style={{ width: "30%" }}>
                    {/* Reversing data button */}
                    <button
                      className="absolute pt-2.5 text-nowrap flex gap-0.5 pr-2"
                      style={{ right: "11%" }}
                      onClick={() => sortColumn(2)}
                    >
                      <div>No of Unique Sales</div>
                      <img
                        src={arrows}
                        style={{ width: "17px", marginTop: "1px" }}
                        alt="arrows-svg"
                      />
                    </button>
                  </div>
                </div>

                {loading ||
                firstSources.length === 0 ||
                firstSources[currentDate] === undefined ? (
                  <FirstLastTouchLoading />
                ) : (
                  <div>
                    {/* All data */}
                    {firstSources[currentDate]?.map((value, index) => (
                      <div key={index}>
                        {/* Only displays current page numbers 15 rows */}
                        {/* {index >= (page * 15) && index < ((page + 1) * 15) ? ( */}

                        <div
                          className="flex text-xs sm:text-sm "
                          style={{ border: "1px solid rgba(0,0,0,0.1)" }}
                        >
                          {/* First sources */}
                          <div
                            className="touch__item pt-2 pb-2 pr-1 pl-2"
                            style={{
                              width: "45%",
                              wordWrap: "break-word",
                              maxWidth: "22vw",
                            }}
                          >
                            {firstSources[currentDate][index]}
                          </div>
                          {/* Last Sources */}
                          <div className="touch__item pt-2 pb-2 pr-1 mx-0 pl-2 w-[55%] break-words max-w-[35vw] sm:max-w-[37vw]">
                            {lastSources[currentDate][index]}
                          </div>
                          {/* Unique Sales Numbers */}
                          <div
                            className="touch__item relative pr-2"
                            style={{ width: "30%" }}
                          >
                            <div
                              className="absolute pt-2.5 text-nowrap flex gap-0.5 pr-3"
                              style={{ right: "11%" }}
                            >
                              {uniqueSales[currentDate][index]}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                    {/* Bottom row -> Total number of unique sales */}
                    <div
                      className="flex"
                      style={{
                        border: "1px solid rgba(0,0,0,0.1)",
                        fontSize: "13px",
                      }}
                    >
                      <div
                        className="mt-2.5 mb-2.5 fw-bold pl-2 text-nowrap"
                        style={{ width: "45%", maxWidth: "22vw" }}
                      >
                        Total Number of Unique Sales
                      </div>
                      <div className="w-[55%] break-words max-w-[35vw] sm:max-w-[37vw]" />
                      {/* Sum of all unique sales numbers */}
                      <div className="relative pr-2" style={{ width: "30%" }}>
                        <div
                          className="absolute mt-2 mb-2 fw-bold pr-3"
                          style={{ right: "11%" }}
                        >
                          {uniqueSales[currentDate].reduce(
                            (sum, value) => sum + value,
                            0
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div>
            <TouchGraph2 />
          </div>
        </div>
      ) : (
        <FirstLastTouchLoading />
      )}
    </>
  );
};

export default FirstLastTouch;
